/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalletLineItem
 */
export interface PalletLineItem {
    /**
     * 箱子页仅支持 2 商品；箱上托由托盘页维护
     * @type {number}
     * @memberof PalletLineItem
     */
    containsType: number;
    /**
     * contains_type=1 时：纸箱 id（箱子页不处理，托盘页维护）
     * @type {number}
     * @memberof PalletLineItem
     */
    boxId?: number;
    /**
     * contains_type=1 且 boxId 为空时：对方箱子的唛头号 markNo（箱子页不处理，托盘页维护）
     * @type {string}
     * @memberof PalletLineItem
     */
    boxMarkNo?: string;
    /**
     * contains_type=2 时：商品 id
     * @type {number}
     * @memberof PalletLineItem
     */
    goodsId?: number;
    /**
     * contains_type=2 时：SKU id
     * @type {number}
     * @memberof PalletLineItem
     */
    skuId?: number;
    /**
     * contains_type=2 时：数量
     * @type {number}
     * @memberof PalletLineItem
     */
    quantity?: number;
}

/**
 * Check if a given object implements the PalletLineItem interface.
 */
export function instanceOfPalletLineItem(value: object): value is PalletLineItem {
    if (!('containsType' in value) || value['containsType'] === undefined) return false;
    return true;
}

export function PalletLineItemFromJSON(json: any): PalletLineItem {
    return PalletLineItemFromJSONTyped(json, false);
}

export function PalletLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalletLineItem {
    if (json == null) {
        return json;
    }
    return {
        
        'containsType': json['containsType'],
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'boxMarkNo': json['boxMarkNo'] == null ? undefined : json['boxMarkNo'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function PalletLineItemToJSON(json: any): PalletLineItem {
    return PalletLineItemToJSONTyped(json, false);
}

export function PalletLineItemToJSONTyped(value?: PalletLineItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'containsType': value['containsType'],
        'boxId': value['boxId'],
        'boxMarkNo': value['boxMarkNo'],
        'goodsId': value['goodsId'],
        'skuId': value['skuId'],
        'quantity': value['quantity'],
    };
}

